<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script setup>
import { nextTick, onMounted } from 'vue'
import { useStore } from 'vuex';
import { refreshRoutes } from '@/router';
import { getRouteList } from "@/api/auth/login/index";
import { useRouter, useRoute } from 'vue-router';

const route = useRoute();
const router = useRouter();
const store = useStore();
const getRoute = (data) => {

  //如果当前路径是登录页，则不调用接口
  const hashPath = window.location.hash.replace('#', '')
  console.log('hashPath:', hashPath) 
  if (hashPath === '/login' || hashPath === '/register' || hashPath === '/forgot' || hashPath === '/') {
    return
  }
  getRouteList().then(result => {
    if (result.data && result.data.length > 0) {
      sessionStorage.setItem("menuList", JSON.stringify(result.data));
      // userStore.setMenuList(result.data);
      refreshRoutes();
    } else {
      ElMessage.error('无路由数据，请联系管理员并重新登录！');
      sessionStorage.clear();
      router.replace('/login');
    }
  }).catch(() => { });
}
onMounted(() => {
  nextTick(() => {
    getRoute()
  })
})
</script>

<style lang="less">
html,
body,
h3,
p {
  margin: 0;
  padding: 0;
}
.layout-padding-view{
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
